import React from 'react';
export const changeLabelColor = ({
  version: 1,
  id: 'change-label-color',
  render: () => <div>Click on the circle to select a label color of your choice.</div>,
  isRoot: true,
  disableNext: false
} as const);